import { useFormikContext } from "formik";

import { FormikTextInput } from "@sso/components/Formik";
import {
  BillableOperation,
  LicenceType,
  PricingFormModel,
  PricingSummaryKeys,
  SoftwareLicenceFormValues,
} from "@sso/types";

import ApiPricingForm from "./apiPricingForm";
import PricingRulesRangeForm from "./pricingRules";

interface PricingTestProps {
  licenceType: LicenceType;
  billableOperations?: BillableOperation[];
}

const PricingForm = ({ licenceType, billableOperations }: PricingTestProps) => {
  const { values, errors } = useFormikContext<PricingFormModel | SoftwareLicenceFormValues>();
  return (
    <>
      <FormikTextInput type="date" name={PricingSummaryKeys.DATE_OF_EFFECT} label="Date of Effect" />
      {licenceType === LicenceType.SINGLE_USER && (
        <FormikTextInput type="number" label={"Price"} name={"pricingRules[0].price"} />
      )}
      <>
        {licenceType === LicenceType.CONCURRENT && (
          <PricingRulesRangeForm
            fieldAccessor="pricingRules"
            rules={values.pricingRules ?? []}
            licenceType={licenceType}
            errors={errors.pricingRules}
          />
        )}
        {licenceType === LicenceType.API && <ApiPricingForm />}
      </>
    </>
  );
};

export default PricingForm;
